import React from 'react'
import { string, object, bool, array, number } from 'prop-types'
import { EventIconSplitHero } from '@/component/Primitive/Events'
import createButtonGroup from '../lib/button-group-creator'
import generateImage from './lib/image-generator'

const EventIconSplitHeroWidget = ({
  pageData,
  buttonGroup,
  images,
  ...other
}) => {
  let image
  if (!images) {
    image = null
  } else if (Object.keys(images).length === 0) {
    image = null
  } else if (!images[Object.keys(images)[0]]) {
    image = null
  } else {
    image = generateImage(images)
  }

  return (
    <EventIconSplitHero
      {...other}
      buttonGroup={createButtonGroup(pageData, buttonGroup)}
      image={image}
    />
  )
}

EventIconSplitHeroWidget.propTypes = {
  title: string,
  subtitle: string,
  description: string,
  buttonGroup: array,
  theme: string,
  inverse: bool,
  icon: string,
  iconSize: number,
  pageData: object,
  images: object
}

export default EventIconSplitHeroWidget
